import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import * as mapboxgl from "mapbox-gl";
import * as MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import { environment } from "../../../environments/environment";
import { ApiCallingService } from "../../services/api-calling.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Globals } from "../../common/global";
import { Router } from "@angular/router";
import { HttpParams } from "@angular/common/http";
import { ConfigApi } from "../../config-api";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

@Component({
  selector: "app-locations",
  templateUrl: "./locations.component.html",
  styleUrls: ["./locations.component.css"],
})
export class LocationsComponent implements OnInit {
  quillConfig = {
    toolbar: [
      ["bold", "italic", "underline", "strike"],
      ["blockquote", "code-block"],
      [{ header: 1 }, { header: 2 }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }],
      [{ direction: "rtl" }],
      [{ size: ["small", false, "large", "huge"] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ["clean"],
      ["link", "image", "video"],
    ],
  };

  @ViewChild("editModal") editModal: any;
  @ViewChild("deleteModal") deleteModal: any;
  private locationIdToDelete: string = "";
  private searchSubject = new Subject<string>();
  searchFilter: string = "";

  LocationDetails: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  totalCount: number = 0;
  loading: boolean = false;
  modeltitle: any;
  detail: any = {
    title: "",
    description: "",
  };
  private mapboxAccessToken = environment.mapbox.accessToken;
  map: any;
  lat: number = 0;
  lng: number = 0;
  selectedLocation: string = "";
  selectedServices: string[] = [];
  images: { file: File | null; url: string }[] = [];
  videos: { file: File | null; url: string }[] = [];
  ServiceList: any;
  userDetails: any;
  editDetails: any;
  IsEdit: boolean = false;
  selectedService: string = "";
  showServiceError: boolean = false;
  showLocationError: boolean = false;
  formSubmitted: boolean = false;

  constructor(
    private router: Router,
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService,
    public globals: Globals,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef
  ) {
    let data = localStorage.getItem("Auth-user");
    if (!data) {
      return;
    }
    try {
      this.userDetails = JSON.parse(data);
    } catch (error) {
      console.error(error);
    }

    this.searchSubject
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.searchFilter = searchTerm;
        this.applyFilters();
      });
  }

  ngOnInit(): void {
    // this.getLocations();
    this.getSelectedService();
  }

  ngAfterViewInit(): void {
    this.loadPage(this.page);
  }

  getSelectedService() {
    this.apiCallingService
      .callAPI({}, "GET", `${ConfigApi.URLS.BOOK_LOCATION.SERVICE_LIST}`)
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.ServiceList = res.data;
            this.totalCount = res.total;
            this.cdr.detectChanges();
          }
        },
        (error) => {
          this.loading = false;
        }
      );
  }

  getLocations(): void {
    this.loading = true;
    const pageIndex = this.page > 0 ? this.page - 1 : 0;
    let params = new HttpParams()
      .set("search", encodeURIComponent(this.searchFilter))
      .set("operator_id", this.userDetails._id)
      .set("page", pageIndex.toString())
      .set("limit", this.pageSize.toString());
    this.apiCallingService
      .callAPI(
        {},
        "GET",
        `${ConfigApi.URLS.BOOK_LOCATION.LIST}?${params.toString()}`
      )
      .subscribe(
        (res) => {
          this.loading = false;
          if (this.apiCallingService.handleSuccess(res)) {
            this.LocationDetails = res.data;
            this.totalCount = res.total;
          }
        },
        (error) => {
          this.loading = false;
        }
      );
  }

  loadPage(page: number): void {
    if (page) {
      this.page = page;
      this.getLocations();
    }
  }

  openModal(targetModal: any, data: any, title: any) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
      size: "lg",
    });
    this.modeltitle = title;
    this.detail = Object.assign({}, data);
    this.resetForm();
    this.initializeMap();
  }

  editLocation(location: any) {
    this.modalService.open(this.editModal, {
      centered: true,
      backdrop: "static",
      size: "lg",
    });
    this.modeltitle = "Edit Location";
    this.detail = Object.assign({}, location);

    this.apiCallingService
      .callAPI({}, "GET", `${ConfigApi.URLS.BOOK_LOCATION.DETAILS}/${location}`)
      .subscribe(
        (res) => {
          this.loading = false;
          if (this.apiCallingService.handleSuccess(res)) {
            this.editDetails = res.data;
            this.IsEdit = true;
            this.detail.title = this.editDetails.title;
            this.detail.description = this.editDetails.description;
            this.selectedServices = [...this.editDetails.services];
            this.lat = this.editDetails.location.coordinates[1];
            this.lng = this.editDetails.location.coordinates[0];
            this.selectedLocation = this.editDetails.address;
            this.images = this.editDetails.images.map((img: any) => ({
              file: null,
              url: img.url || img,
            }));

            this.videos = this.editDetails.videos.map((vid: any) => ({
              file: null,
              url: vid.url || vid,
            }));

            this.selectedService = "";

            this.showServiceError = false;
            this.showLocationError = false;
            this.formSubmitted = false;

            this.initializeMap();
          }
        },
        (error) => {
          this.loading = false;
        }
      );
  }

  resetForm() {
    this.detail = {
      title: "",
      description: "",
    };
    this.selectedServices = [];
    this.selectedService = "";
    this.images = [];
    this.videos = [];
    this.lat = 0;
    this.lng = 0;
    this.selectedLocation = "";
    this.showServiceError = false;
    this.showLocationError = false;
    this.formSubmitted = false;
    this.IsEdit = false;
  }

  initializeMap() {
    setTimeout(() => {
      (mapboxgl as any).accessToken = this.mapboxAccessToken;
      const initialLat = this.lat;
      const initialLng = this.lng;

      const mapContainer = document.getElementById("storeLocationMap");
      if (!mapContainer) {
        console.error("Map container not found");
        return;
      }

      if (this.map) {
        this.map.remove();
      }

      this.map = new mapboxgl.Map({
        container: "storeLocationMap",
        style: "mapbox://styles/mapbox/streets-v11",
        center: [initialLng, initialLat],
        zoom: 12,
      });

      const geocoder = new (MapboxGeocoder as any)({
        accessToken: (mapboxgl as any).accessToken,
        mapboxgl: mapboxgl,
        placeholder: "Search for store location",
        marker: false,
        flyTo: {
          speed: 1.2,
          zoom: 12,
        },
      });

      this.map.addControl(geocoder, "top-left");

      let marker: mapboxgl.Marker | any = null;

      const placeMarker = (lng: number, lat: number) => {
        this.lat = lat;
        this.lng = lng;

        this.showLocationError = false;

        if (!marker) {
          marker = new mapboxgl.Marker({ draggable: true })
            .setLngLat([lng, lat])
            .addTo(this.map);
        } else {
          marker.setLngLat([lng, lat]);
        }

        this.map.flyTo({
          center: [this.lng, this.lat],
          zoom: 12,
          centered: true,
        });

        this.reverseGeocode({ lng, lat });
      };

      this.map.on("click", (e: any) => {
        placeMarker(e.lngLat.lng, e.lngLat.lat);
      });

      geocoder.on("result", (event: any) => {
        const coordinates = event.result.center;
        placeMarker(coordinates[0], coordinates[1]);
        this.selectedLocation = event.result.place_name;
      });

      this.map.on("load", () => {
        if (this.lat && this.lng) {
          placeMarker(this.lng, this.lat);
        }
      });
    }, 100);
  }

  reverseGeocode(lngLat: any) {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${lngLat.lng},${lngLat.lat}.json?access_token=${this.mapboxAccessToken}`;
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data.features && data.features.length > 0) {
          this.selectedLocation = data.features[0].place_name;
          this.showLocationError = false;
        } else {
          this.selectedLocation = "Location not found";
        }
      })
      .catch((error) => {
        console.error("Error reverse geocoding:", error);
        this.selectedLocation = "Error retrieving address";
      });
  }

  onImageSelect(event: any) {
    const files = event.target.files;
    if (files) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.images.push({
            file: file,
            url: e.target.result,
          });
        };
        reader.readAsDataURL(file);
      }
    }
  }

  removeImage(index: number) {
    this.images.splice(index, 1);
  }

  onVideoSelect(event: any) {
    const files = event.target.files;
    if (files) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.videos.push({
            file: file,
            url: e.target.result,
          });
        };
        reader.readAsDataURL(file);
      }
    }
  }

  removeVideo(index: number) {
    this.videos.splice(index, 1);
  }

  onSubmit() {
    this.formSubmitted = true;

    this.showServiceError = this.selectedServices.length === 0;

    this.showLocationError =
      !this.selectedLocation || this.selectedLocation === "";

    if (
      this.showServiceError ||
      this.showLocationError ||
      !this.detail.title ||
      !this.detail.description
    ) {
      return;
    }

    const formData = new FormData();
    formData.append("operator_id", this.userDetails._id);
    formData.append("title", this.detail.title);
    formData.append("description", this.detail.description);
    formData.append("latitude", this.lat.toString());
    formData.append("longitude", this.lng.toString());
    formData.append("address", this.selectedLocation);

    const serviceIds = this.selectedServices.map((service: any) => {
      return typeof service === "object" && service !== null
        ? service._id
        : service;
    });
    formData.append("services", JSON.stringify(serviceIds));

    const existingImageUrls = this.images
      .filter((image) => !image.file && image.url)
      .map((image) => image.url);

    if (existingImageUrls.length > 0) {
      formData.append("existingImage", JSON.stringify(existingImageUrls));
    }

    this.images.forEach((image) => {
      if (image.file) {
        formData.append("image", image.file);
      }
    });

    const existingVideoUrls = this.videos
      .filter((video) => !video.file && video.url)
      .map((video) => video.url);

    if (existingVideoUrls.length > 0) {
      formData.append("existingVideo", JSON.stringify(existingVideoUrls));
    }

    this.videos.forEach((video) => {
      if (video.file) {
        formData.append("video", video.file);
      }
    });

    const url = this.IsEdit
      ? `${ConfigApi.URLS.BOOK_LOCATION.UPDATE}/${this.editDetails._id}`
      : `${ConfigApi.URLS.BOOK_LOCATION.CREATE}`;

    const method = this.IsEdit ? "PUT" : "POST";

    this.apiCallingService.callAPI(formData, method, url).subscribe(
      (res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.toastr.success(res.msg);
          this.getLocations();
          this.modalService.dismissAll();
        }
      },
      (err) => {
        this.toastr.error(
          this.IsEdit
            ? "Failed to update location"
            : "Failed to create location"
        );
      }
    );
  }

  onServiceSelect(event: any) {
    const selectedId = event.target.value;
    if (selectedId) {
      const exists = this.selectedServices.some((service: any) => {
        const serviceId =
          typeof service === "object" && service !== null
            ? service._id
            : service;
        return serviceId === selectedId;
      });

      if (!exists) {
        this.selectedServices.push(selectedId);
        this.showServiceError = false;
      }
    }

    this.selectedService = "";
  }

  getServiceName(serviceItem: any): string {
    if (
      typeof serviceItem === "object" &&
      serviceItem !== null &&
      serviceItem.serviceName
    ) {
      return serviceItem.serviceName;
    }

    let serviceId = serviceItem;
    if (typeof serviceItem === "object" && serviceItem !== null) {
      serviceId = serviceItem._id;
    }

    if (!this.ServiceList || !Array.isArray(this.ServiceList)) {
      return "Loading...";
    }
    const service = this.ServiceList.find((s: any) => {
      return s._id === serviceId;
    });

    return service ? service.serviceName : "Unknown";
  }

  removeService(serviceItem: any): void {
    const index = this.selectedServices.findIndex((service: any) => {
      const currentServiceId =
        typeof service === "object" && service !== null ? service._id : service;
      const removeServiceId =
        typeof serviceItem === "object" && serviceItem !== null
          ? serviceItem._id
          : serviceItem;
      return currentServiceId === removeServiceId;
    });

    if (index > -1) {
      this.selectedServices.splice(index, 1);

      // Check if services array is empty and update error state
      if (this.selectedServices.length === 0 && this.formSubmitted) {
        this.showServiceError = true;
      }
    }
  }

  closeBtnClick() {
    this.modalService.dismissAll();
    this.IsEdit = false;
    this.resetForm();

    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }

  deleteLocation(id: string) {
    this.apiCallingService
      .callAPI({}, "DELETE", `${ConfigApi.URLS.BOOK_LOCATION.DELETE}/${id}`)
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success(res.msg);
            this.getLocations();
          }
        },
        (error) => {
          this.loading = false;
          this.toastr.error("Failed to delete location");
        }
      );
  }

  openDeleteModal(targetModal: any, id: string) {
    this.locationIdToDelete = id;
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  confirmDelete() {
    this.deleteLocation(this.locationIdToDelete);
    this.modalService.dismissAll();
  }

  closeDeleteModalClick() {
    this.modalService.dismissAll();
    this.locationIdToDelete = "";
  }

  onSearchFilterInput(event: any) {
    this.searchSubject.next(event.target.value);
  }

  applyFilters() {
    this.page = 1;
    this.getLocations();
  }
}
